// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BnVY","colBig":"styles_colBig__3UWRb","colSmall":"styles_colSmall__1j6hs","shopifyNameWrapper":"styles_shopifyNameWrapper__jKtrZ"};